export enum DashboardWidgetType {
  PF_SUPPORT = 'pf_support',
  BIDS_REMAINING = 'bids_remaining',
  LOCAL_JOBS = 'local_jobs',
  MY_PROFILE = 'my_profile',
  POLLS = 'polls',
  ZERO_COMMISSION = 'zero_commission',
}

export interface DashboardWidget {
  readonly id: DashboardWidgetType;
}
